<template>
  <div class="notebook body">
    <el-container>
      <!-- <PayAside /> -->

      <el-main>
        <el-row class="search">
          <el-col :span="24">
            <div class="bg-white">
              <label for="searchForCustomer">اختر اسم العميل</label>
              <el-autocomplete
                ref="productQuery"
                v-model="state"
                id="searchForCustomer"
                :fetch-suggestions="querySearchAsync"
                placeholder="بحث المنتجات بالاسم"
                @select="handleSelect"
              >
                <template slot-scope="{ item }">
                  <div class="body-content">
                    <div class="name">{{ item.name }}</div>

                    <div class="address">{{ item.address }}</div>

                    <div class="phone">{{ item.phone }}</div>
                  </div>
                </template>
              </el-autocomplete>
            </div>
          </el-col>
        </el-row>
        <el-row class="customers">
          <el-col :xl="12" :lg="12" :md="24" :sm="24" class="pl-2"
            ><div class="bg-white">
              <div class="headerSide bg-green">
                <p class="text">حركه المدينين</p>
                <p class="num"><span>139,608</span> ج.م</p>
              </div>
              <div class="content scroll-green">
                <div
                  class="customer"
                  v-for="(item, index) in customerInfo"
                  :key="index"
                >
                  <el-row>
                    <el-col :span="9" class="alignItem">
                      <p class="text">{{ item.name }}</p>
                    </el-col>
                    <el-col :span="15" class="d-flex"
                      ><p class="num">{{ item.number }}</p>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="قيمه التحصيل"
                        v-model="item.value"
                      />
                      <button class="btn btn-green">تم</button></el-col
                    >
                  </el-row>
                </div>
              </div>
            </div></el-col
          >
          <el-col :xl="12" :lg="12" :md="24" :sm="24"
            ><div class="bg-white">
              <div class="headerSide bg-red">
                <p class="text">حركه الدائنين</p>
                <p class="num"><span>7,608</span> ج.م</p>
              </div>
              <div class="content scroll-red">
                <div
                  class="customer"
                  v-for="(item, index) in customerInfo"
                  :key="index"
                >
                  <el-row>
                    <el-col :span="9" class="alignItem">
                      <p class="text">{{ item.name }}</p>
                    </el-col>
                    <el-col :span="15" class="d-flex"
                      ><p class="num">{{ item.number }}</p>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="قيمه التحصيل"
                        v-model="item.value"
                      />
                      <button class="btn btn-red">تم</button></el-col
                    >
                  </el-row>
                </div>
              </div>
            </div></el-col
          >
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import PayAside from "@/components/PayAside.vue";
// import axiosApi from "@/plugins/axios.js";

export default {
  name: "Notebook",
  // components: { PayAside },
  data() {
    return {
      links: [],
      state: "",
      timeout: null,
      customerInfo: [
        {
          name: "محمد سامي",
          number: 7.608,
          value: null,
        },
        {
          name: " سوبر ماركت الامانه",
          number: 139.608,
          value: null,
        },
        {
          name: "محمد سامي",
          number: 7.608,
          value: null,
        },
        {
          name: "محمد سامي",
          number: 7.608,
          value: null,
        },
        {
          name: " سوبر ماركت الامانه",
          number: 139.608,
          value: null,
        },
      ],
    };
  },
  methods: {
    loadAll() {
      return [
        {
          value: "vueراسيلاؤصتلؤسللللللللللللللل",
          link: "https://github.com/vuejs/vue",
        },
        { name: "ايه محمد مهدى", address: "الاسماعيليه", phone: "01025572557" },
        { name: "ايه محمد مهدى", address: "الاسماعيليه", phone: "01025572557" },
        { name: "ايه محمد مهدى", address: "الاسماعيليه", phone: "01025572557" },
        { name: "ايه محمد مهدى", address: "الاسماعيليه", phone: "01025572557" },
      ];
    },
    querySearchAsync(queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createFilter(queryString) {
      return (link) => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    },
  },
  mounted() {
    this.links = this.loadAll();
    let newElement = document.createElement("div");
    newElement.classList.add("header");
    newElement.innerHTML = `<div class="head-phone">
                                <h6>التليفون</h6>
                            </div> 
                            <div class="head-address"> 
                                <h6> العنوان</h6>
                            </div> 
                            <div class="head-name"> 
                                <h6>الاسم</h6>
                            </div>`;

    let element = this.$refs.productQuery.$el.childNodes[1];
    element.prepend(newElement);
  },
};
</script>
<style lang="sass" >
@import "../../styles/notebook.scss"
</style>
